import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import i18n from 'locales/i18n';
import { IMusicProductPhysicalSearch } from 'services/music-product-physical/types/query';
import { STATUS } from 'services/types';
import { booleanLabel } from 'utils/components/inputs/booleanLabel';

registerQueryFilterLabels<IMusicProductPhysicalSearch>('musicProductsPhysical', {
  status: ({ value }) =>
    value !== undefined ? i18n.t(`enum.STATUS.${STATUS[value as STATUS]}`) : null,

  hasDuplicatedArtist: booleanLabel('input.label.hasDuplicatedArtist'),
  hasContracts: booleanLabel('input.label.hasContracts'),
});
